import React, { useContext, useEffect, useState } from 'react'
import Typography from '@material-ui/core/Typography'
import Row from '../../../components/layout/Row'
import clsx from 'clsx'
import CartItem from '../../../components/cart/CartItem'
import getServerSideAPIProps from '../../../props/getServerSideAPIProps'
import { makeStyles } from '@material-ui/core/styles'
import { Grid, Hidden, Divider, Container, Button, IconButton, Snackbar } from '@material-ui/core'
import { price } from '../../../lib/react-storefront/utils/format'
import Spacer from '../../../components/layout/Spacer'
import { Hbox } from '../../../components/layout/Box'
import SessionContext from '../../../contexts/SessionContext'
import get from 'lodash/get'
import { useRouter } from 'next/router'
import FormControl from '@material-ui/core/FormControl'
import InputAdornment from '@material-ui/core/InputAdornment'
import Input from '@material-ui/core/Input'

import { Alert } from '@material-ui/lab'
import InfoIcon from '@material-ui/icons/Info'
import RemoveDialog from '../../../components/cart/RemoveDialog'
import InfoDialog from '../../../components/cart/InfoDialog'
import Link from 'next/link'
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
const styles = theme => ({
  root: {
    paddingBottom: '64px',
  },
  checkoutPanel: {
    backgroundColor: theme.palette.grey['200'],
    borderRadius: theme.shape.borderRadius,
    padding: `${theme.spacing(2)}px`,
  },
  total: {
    fontWeight: 'bold',
  },
  checkoutButton: {
    width: '100%',
  },
  docked: {
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.subtitle1.fontSize,
      padding: `${theme.spacing(2)}px`,
      position: 'fixed',
      left: 0,
      bottom: 0,
      width: '100%',
      zIndex: 10,
      borderRadius: '0',
      boxShadow: 'none',
    },
  },
  cusBgColor: c => ({
    backgroundColor: c.backgroundColor,
    color: c.color,
  }),
  cusBorder: c => ({
    border: c.border,
    margin: '0 0 0 -1px',
    padding: '5px 0',
  }),
})

const useStyles = makeStyles(styles)

export default function Cart(props) {
  const { session, actions, config } = useContext(SessionContext)
  let router = useRouter()
  let { storeSlug,ordertype } = router.query
  console.log("ordertype",ordertype)
  let themeColor =
    config && config.hasOwnProperty('web_theme_color') && config.web_theme_color != ''
      ? config.web_theme_color
      : '#1e3041'
  let fontColor =
    config && config.hasOwnProperty('web_theme_font_color')
      ? config.web_theme_font_color
      : '#FFFFFF'
  const c = {
    color: `${fontColor}` + ' !important',
    backgroundColor: `${themeColor}` + ' !important',
    border: '1px solid' + `${themeColor}` + ' !important',
  }

  const classes = useStyles(c)
  let customtip = session.customtip
 
  const items = get(session, 'cart.items') || []
  let service_charge = session.service_charge ? parseFloat(session.service_charge) : 0
  let min_order = session.min_order ? parseFloat(session.min_order) : 0
  let service_charge_type = session.service_charge_type
  let service_charge_label = session.service_charge_label
  let subtotal = items.reduce(
    (a, b) => a + (b.quantity * parseFloat(b.price) - (b.tax.inclusive == 1 ? b.tax.total : 0)),
    0
  )

  let additional_charges_total = items.reduce((a, b) => {
    let additional_charge = 0
    for (let index in b.additional_charges) {
      const addcharge = b.additional_charges[index]
      additional_charge += parseFloat(addcharge.amount)
    }
    return a + additional_charge
  }, 0)
 
  let bottledeposit = items.reduce((a, b) => {
    return a + (b.bottledeposit ? parseFloat(b.bottledeposit) : 0)
  }, 0)
  let service_addnl_charges = session.service_addnl_charges ? session.service_addnl_charges : 0
  let delivery_addnl_charges = session.delivery_addnl_charges ? session.delivery_addnl_charges : 0
  let tips = session.hasOwnProperty('tips') && session.tips ? session.tips : []
 
  let defaulttip = 'custom'
  if (get(session, 'cart') && get(session, 'cart').hasOwnProperty('tip_type')) {
    defaulttip = get(session, 'cart.tip_type')
  } else {
    for (let index in tips) {
      const tip = tips[index]
      if (tip.default) {
        defaulttip = tip.amount
      }
    }
  }

  const [productError, setProductError] = React.useState(null)
  const errorType = 'error'

  const [selectedTip, SetTipObject] = useState({})
  const [tipAmount, setTipAmount] = useState(0.0)
  const [tipType, setTipType] = useState(defaulttip)

  const [customTipAmount, setCustomTipAmount] = useState(2)
  const [openRemoveAll, setOpenRemoveAll] = useState(false)
  const [openInfoDialog, setOpenInfoDialog] = useState(false)
  const [closeInfoDialog, setCloseInfoDialog] = useState(false)
  const [tip_item_id, setTipItemId] = useState(session.tip_item_id)
  const handleCloseError = () => {
    setProductError(null)
  }

  const handleUpdateQuantity = async (product, mod, size, quantity) => {
    try {
      // send the data to the server
      await actions.updateCart({
        item: product,
        mod: mod,
        size: size,
        quantity,
      })
    } catch (e) {
      setProductError(e.message)
    }
  }

  const handleRemove = product => {
    actions.removeCartItem({
      item: product,
    })
  }
  /**Calculate custom tip amount taxes */
  const handleCusTipClick = value => {
    setTipType('custom')

    setCustomTipAmount(
      get(session, 'cart') && get(session, 'cart').hasOwnProperty('tip_amount')
        ? get(session, 'cart.tip_amount')
        : session.customtip
        ? session.customtip
        : 0
    )

    setTipAmount(
      get(session, 'cart') && get(session, 'cart').hasOwnProperty('tip_amount')
        ? get(session, 'cart.tip_amount')
        : session.customtip
        ? session.customtip
        : 0
    )
    localStorage.setItem('defaulttip', 'custom')
    localStorage.setItem(
      'tipamount',
      get(session, 'cart') && get(session, 'cart').hasOwnProperty('tip_amount')
        ? get(session, 'cart.tip_amount')
        : session.customtip
        ? session.customtip
        : 0
    )
  }

  const handleCusTipAmountChange = e => {
    let a = e.target.value
    if (a < 0) {
      a = a * -1
    }
    setTipAmount(a)
    setCustomTipAmount(a)
    localStorage.setItem('tipamount', a)
  }
  /**Calculate tip taxes for  percent tip amount */
  const handleTipClick = value => {
    localStorage.setItem('defaulttip', value)
    setTipAmount(((subtotal / 100) * value).toFixed(2))
    setTipType(value)
  }
  const calculateTipTaxes = async value => {
    let headers = {
      'Content-Type': 'application/json',
    }
    let res = await fetch('/api/store/' + storeSlug + '/cart/calculateTipTaxes', {
      method: 'post',
      headers: headers,
      body: JSON.stringify({
        amount: value,
      }),
    })
    let data = await res.json()
    if (data) {
      SetTipObject(data.tip_tax)
    }
  }
  useEffect(() => {
    if (!get(session, 'cart.items')) {
      if (localStorage.getItem('defaulttip') != null) {
        localStorage.removeItem('defaulttip')
      }
      if (localStorage.getItem('tipamount') != null) {
        localStorage.removeItem('tipamount')
      }
    } else {
      if (tip_item_id) {
     
        setTipType(
          localStorage.getItem('defaulttip') != null
            ? localStorage.getItem('defaulttip')
            : defaulttip
        )

        setCustomTipAmount(
          localStorage.getItem('tipamount') != null ? localStorage.getItem('tipamount') : customtip
        )
        setTipAmount(
          localStorage.getItem('tipamount') != null ? localStorage.getItem('tipamount') : customtip
        )
      }
    }
  }, [tip_item_id])
  useEffect(() => {
    if (tip_item_id) {
      setTipType(
        localStorage.getItem('defaulttip') != null ? localStorage.getItem('defaulttip') : defaulttip
      )
      tipType != 'custom'
        ? setTipAmount(((subtotal / 100) * parseInt(tipType)).toFixed(2))
        : setTipAmount(customtip)
    }
  }, [subtotal])

  useEffect( () => {
    if (tip_item_id) {
      async function calTip(){
        tipType != 'custom'
        ? setTipAmount(((subtotal / 100) * parseInt(tipType)).toFixed(2))
        : setTipAmount(
            localStorage.getItem('tipamount') != null
              ? localStorage.getItem('tipamount')
              : customtip
          )
        if (tipType == 'custom') {
          setCustomTipAmount(
            localStorage.getItem('tipamount') != null ? localStorage.getItem('tipamount') : customtip
          )
        }

        let data = await calculateTipTaxes(tipType == 'custom' ? customTipAmount : tipAmount)
        if (data) {
          SetTipObject(data.tip_tax)
        }
      }
      calTip()
    }
  }, [tipAmount, customTipAmount])

  useEffect(() => {
    setTipItemId(session.tip_item_id)
  }, [session])

  let ser_charge =
    service_charge_type == 'dollar' ? service_charge : (subtotal * service_charge) / 100
  let tip_addnl_charges =
    selectedTip && selectedTip.hasOwnProperty('tip_addnl_charges')
      ? parseFloat(selectedTip.tip_addnl_charges)
      : 0
  let tip_addnl_taxes =
    selectedTip && selectedTip.hasOwnProperty('total') ? parseFloat(selectedTip.total) : 0
  let is_delivery_enabled = config.hasOwnProperty('enable_delivery')
    ? config.enable_delivery
    : false
  let delivery_fee = is_delivery_enabled
    ? get(session, 'delivery_fee')
      ? get(session, 'delivery_fee')
      : 0
    : 0


  return (
    <Container className={(classes.root, 'cart-container')}>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={productError != null}
        autoHideDuration={6000}
        onClose={handleCloseError}
      >
        <Alert onClose={handleCloseError} severity={errorType}>
          {productError}
        </Alert>
      </Snackbar>
      <Row>
        <Typography variant="h6" className="cart-head MuiGrid-grid-md-8">
          My Cart ({items.length} {items.length === 1 ? 'item' : 'items'}){' '}
          {items.length ? (
            <Button
              className="mob-btn"
              variant="contained"
              color="primary"
              onClick={() => {
                setOpenRemoveAll(true)
              }}
            >
              Remove All Items
            </Button>
          ) : null}
        </Typography>
      </Row>
      <Row>
        <Grid container spacing={4} direction="row">
          <Grid className="highlight-txt" item xs={12} lg={8} md={8}>
          {items.length > 0 && (
            <Row>
              <Grid container spacing={4} direction="row" className="pr-4 desktop-show">
                <Grid className="highlight-txt" item xs={12} lg={6} md={6}>
                  <b>Item Detail</b>
                </Grid>
                <Grid className="highlight-txt" item xs={12} lg={3} md={3}>
                  <b>Qty</b>
                </Grid>
                <Grid className="highlight-txt" item xs={12} lg={3} md={3}>
                  <b>Item Total</b>
                </Grid>
              </Grid>
            </Row>
          )}
            
              {items.map((product, i) => (
                <CartItem
                  key={i}
                  updateQuantity={handleUpdateQuantity}
                  remove={handleRemove}
                  product={product}
                />
              ))}
            
            {/* {items.length === 0 && (
             
             
            )} */}
          </Grid>
          {items.length === 0 ? <>  
            <Container maxWidth="lg" align="center">            
                <Typography variant="body1">There are no items in your cart.</Typography>
                 <AddShoppingCartIcon className='empty-cart'/>  <br/>
                
                  <Button className="continue-shopping-btn" variant="contained" color="primary">
                      <Link
                            as={'/store/' + storeSlug}
                            href="/store/[storeSlug]"
                          > 
                    Continue Shopping
                  </Link></Button>
              
              </Container>
                </>: (
            <Grid item xs={12} lg={4} md={4}>
              <div className={classes.checkoutPanel}>
                <Hbox alignItems="flex-start">
                  <div>
                    <Typography variant="subtitle2" className={classes.total}>
                      Subtotal
                    </Typography>
                  </div>
                  <Spacer />
                  <Typography variant="subtitle2" className={classes.total}>
                    {price(subtotal, { currency: get(session, 'currency') })}
                  </Typography>
                </Hbox>

                <Hbox alignItems="flex-start">
                  <div>
                    <Typography variant="subtitle2" className={classes.total}>
                      Tax + Fees{' '}
                      <IconButton className='taxFees-icon'
                        size="small"
                        onClick={() => {
                          setOpenInfoDialog(true)
                        }}
                      >
                        <InfoIcon />
                      </IconButton>
                    </Typography>
                  </div>
                  <Spacer />
                  <Typography variant="subtitle2" className={classes.total}>
                    {price(
                      items.reduce((a, b) => a + parseFloat(b.tax.total), 0) +
                        ser_charge +
                        (get(session, 'service_tax') ? get(session, 'service_tax').total : 0) +
                        (get(session, 'delivery_tax') ? get(session, 'delivery_tax').total : 0) +
                        additional_charges_total +
                        bottledeposit +
                        service_addnl_charges +
                        delivery_addnl_charges +
                        tip_addnl_charges +
                        tip_addnl_taxes,
                      { currency: get(session, 'currency') }
                    )}
                  </Typography>
                </Hbox>
                {is_delivery_enabled && (
                  <Hbox alignItems="flex-start">
                    <div>
                      <Typography variant="subtitle2" className={classes.total}>
                        Delivery Fee
                      </Typography>
                    </div>
                    <Spacer />
                    <Typography variant="subtitle2" className={classes.total}>
                      {price(delivery_fee, {
                        currency: get(session, 'currency'),
                      })}
                    </Typography>
                  </Hbox>
                )}
                {tip_item_id && (
                  <Hbox alignItems="flex-start">
                    <div>
                      <Typography variant="subtitle2" className={classes.total}>
                        Tip
                      </Typography>
                    </div>
                    <Spacer />
                    <Typography variant="subtitle2" className={classes.total}>
                      {price(tipAmount, { currency: get(session, 'currency') })}
                    </Typography>
                  </Hbox>
                )}
                {tip_item_id && (
                  <Grid container className="cart-tip" direction="row" alignItems="center">
                    {tips.map(tip => (
                      <Grid
                        onClick={e => handleTipClick(tip['amount'])}
                        item
                        xs={3}
                        lg={3}
                        md={3}
                        className={
                          classes.cusBorder +
                          (tipType == parseInt(tip['amount']) ? ' ' + classes.cusBgColor : '')
                        }
                      >
                        {tip['amount']}%
                      </Grid>
                    ))}

                    <Grid
                      onClick={e => handleCusTipClick(customTipAmount)}
                      item
                      xs={3}
                      lg={3}
                      md={3}
                      className={
                        classes.cusBorder + (tipType == 'custom' ? ' ' + classes.cusBgColor : '')
                      }
                    >
                      Custom
                    </Grid>
                  </Grid>
                )}

                {tip_item_id && tipType == 'custom' && (
                  <FormControl size="small" fullWidth className={classes.margin}>
                    <Input
                      type="number"
                      id="standard-adornment-amount"
                      value={customTipAmount}
                      onChange={e => handleCusTipAmountChange(e)}
                      startAdornment={<InputAdornment position="start">$</InputAdornment>}
                    />
                  </FormControl>
                )}

                <Hidden implementation="css">
                  <Row className="space-5">
                    <Divider />
                  </Row>
                </Hidden>

                <Hbox alignItems="flex-start" className="text-large">
                  <div>
                    <Typography variant="subtitle2" className={classes.total}>
                      Total
                    </Typography>
                  </div>
                  <Spacer />
                  <Typography variant="subtitle2" className={classes.total}>
                    {price(
                      items.reduce((a, b) => {
                        return a + (b.quantity * parseFloat(b.price) + (b.tax.inclusive == 1 ? 0 : parseFloat(b.tax.total)))
                      }, 0) +
                        additional_charges_total +
                        bottledeposit +
                        service_addnl_charges +
                        delivery_addnl_charges +
                        delivery_fee +
                        ser_charge +
                        (tipAmount ? parseFloat(tipAmount) : 0) +
                        (get(session, 'service_tax') ? get(session, 'service_tax').total : 0) +
                        (get(session, 'delivery_tax') ? get(session, 'delivery_tax').total : 0) +
                        tip_addnl_charges +
                        tip_addnl_taxes,

                      { currency: get(session, 'currency') }
                    )}
                  </Typography>
                </Hbox>

                <div className="text-large">
                  {items.length === 0 ? null : (
                    <div>
                      {parseFloat(min_order) > subtotal && (
                        <Alert severity="error">
                          Minimum Order Subtotal: $ {parseFloat(min_order).toFixed(2)}
                        </Alert>
                      )}
                      <Button
                        color="primary"
                        variant="contained"
                        disabled={parseFloat(min_order) > subtotal}
                        onClick={() => {
                          localStorage.setItem('tipamount', tipAmount)

                          localStorage.setItem('defaulttip', tipType)
                          router.push(
                            '/store/[storeSlug]/checkout',
                            '/store/' + storeSlug + '/checkout'
                          )
                        }}
                        className={clsx(classes.checkoutButton, classes.docked)}
                      >
                        Checkout
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </Grid>
          )}
        </Grid>
      </Row>
      <RemoveDialog
        open={openRemoveAll}
        setOpen={setOpenRemoveAll}
        name={false}
        action={actions.removeAllFromCart}
      />
      <InfoDialog
        open={openInfoDialog}
        setOpen={setOpenInfoDialog}
        title={'Tax + Fees'}
        info={
          <div>
            <div>
              {service_charge_label} :{' '}
              <span style={{ float: 'right' }}>
                {price(parseFloat(ser_charge).toFixed(2), { currency: get(session, 'currency') })}
              </span>
            </div>
            <div>
              {session.hasOwnProperty('bottledeposit_label')
                ? session.bottledeposit_label
                : 'Bottle Deposit'}{' '}
              :{' '}
              <span style={{ float: 'right' }}>
                {price(bottledeposit, { currency: get(session, 'currency') })}
              </span>
            </div>
            <div>
              Additional Charges :{' '}
              <span style={{ float: 'right' }}>
                {price(
                  additional_charges_total +
                    service_addnl_charges +
                    delivery_addnl_charges +
                    tip_addnl_charges,
                  {
                    currency: get(session, 'currency'),
                  }
                )}
              </span>
            </div>
            <div>
              {' '}
              Taxes:{' '}
              <span style={{ float: 'right' }}>
                {price(
                  items.reduce((a, b) => a + parseFloat(b.tax.total), 0) +
                    (get(session, 'service_tax') ? get(session, 'service_tax').total : 0) +
                    (get(session, 'delivery_tax') ? get(session, 'delivery_tax').total : 0) +
                    tip_addnl_taxes,
                  { currency: get(session, 'currency') }
                )}
              </span>
            </div>
          </div>
        }
        close={closeInfoDialog}
        onClose={setCloseInfoDialog}
      ></InfoDialog>
    </Container>
  )
}

export const getServerSideProps = getServerSideAPIProps('/store/[storeSlug]/cart')